import React, { useEffect } from 'react'
import { Card, CardContent, Chip, Typography, CircularProgress, Button, Grid, Tooltip, Stack, IconButton } from '@mui/material';
import useSystemState from '~/features/System/stores/SystemState';
import useDispatchState from '~/features/Dispatch/stores/DispatchState';
import { useHookstate, useState } from "@hookstate/core";
import { getDispatchByIdService } from '~/features/Dispatch/services/index';
import useMapState, { useMarkerState } from '~/features/Map/stores/MapState';
import { LatLng } from 'leaflet';
import { useLang } from '~/hooks/useLang';
import { useLocation } from 'react-router-dom';
import useSurveillanceReportingState from '~/features/VideoMonitoring/stores/SurveillanceReportingState';
import useUserState from '~/features/User/stores/UserState';
import { convertMsToTimeFriendly, dateTimeFormat } from '~/utils/dateTime';
import Close from '@mui/icons-material/Close';
import useOccurrenceState from '~/features/Occurrence/stores/OccurrenceState';
import useOccurrenceCommentState from '~/features/Occurrence/stores/OccurrenceCommentState';
import { parseDataDispatch } from '~/features/Dispatch/utils/parsers';

const elapsedTime = (initialDateTime?: string): string => {
  if (initialDateTime) {
    const dataInicial = new Date(initialDateTime)
    const dataAtual = new Date();
    const tempoDecorrido = dataAtual.getTime() - dataInicial.getTime();
    return convertMsToTimeFriendly(tempoDecorrido);
  }
  else
    return 'N/D';
}

export default function MarkerPopupContentDispatchHistoric({ id, status, code, typeSubtype, location, dispatchedAt, closeThisPopUp, openThisPopUp }) {
  const { getStatusColors } = useSystemState();
  const { dispatch, syncDispatchFromId, dispatchStatusActions, dispatchHistoric } = useDispatchState();
  const { canClosePopup } = dispatchStatusActions();
  const { forceClosePopup } = useMarkerState();
  const dispatchHistoricInfo = dispatchHistoric();
  const dispatchInfo = dispatch();
  const occurrence = dispatchInfo.occurrence;
  const isAwaiting = useState(false);
  const statusColors = getStatusColors(status);
  const { markers } = useMapState();
  const { translate } = useLang();
  const { windowManager } = useSystemState();
  const { surveillanceReportingStates } = useSurveillanceReportingState()
  const { searchDispatches, showCheckbox, searchOccurrence } = surveillanceReportingStates();
  const { verifyPermission } = useUserState();
  const { pathname } = useLocation();
  const existMarker = useHookstate<string[]>([])
  const isVideoMonitoringPage = pathname === '/video-monitoring';

  const handleImportDispatch = async (dispatchId: number, showOccurrenceWindow = false) => {
    isAwaiting.set(true);
    searchDispatches.set('');
    searchOccurrence.set('');
    const dispatchData = parseDataDispatch(await getDispatchByIdService(id).finally(() => {
      isAwaiting.set(false)
      if (showOccurrenceWindow) {
        if (window.location.pathname == '/dispatch/historic-map') {
          windowManager().dispatchViewMode.open.set(true)
        }
      } else {
        searchDispatches.set(code);
        searchOccurrence.set(occurrence.id.get() as string)
      }
      closeThisPopUp()
    }))
    dispatchHistoricInfo.set(dispatchData);
  }

  useEffect(() => {
    existMarker.set(Object.keys(markers()['dispatchHistoric'].get()).filter((item) => item == String(id)))
    if (!existMarker.get().length) {
      closeThisPopUp()
    }

  }, [forceClosePopup.get()])


  return (
    <Card sx={{ backgroundColor: 'transparent', backgroundImage: 'none', boxShadow: 'none' }}>
      <CardContent sx={{ padding: '1em 0 1em 0', textAlign: "center" }} >
        {code ?
          <Stack direction='row' alignItems='center' gap={1} >
            <Tooltip title={`Despachado em: ${dispatchedAt ? dateTimeFormat(dispatchedAt?.toString()) : ''}`} placement='top'>
              <Chip variant={'outlined'} label={elapsedTime((dispatchedAt ? dispatchedAt?.toString() : ''))} />
            </Tooltip>
            <Chip onClick={() => {
              handleImportDispatch(id, true)
              showCheckbox.set(false)
            }}
              sx={{
                background: statusColors.main,
                color: statusColors.contrastText,
                '&:hover': {
                  background: statusColors.dark,
                },
              }}
              label={isAwaiting.get() ? <CircularProgress sx={{ color: statusColors.contrastText }} size={30} /> : <Typography variant="subtitle1" >{code}</Typography>}
            />
            <IconButton size='small' onClick={() => closeThisPopUp()}>
              <Close fontSize='small' />
            </IconButton>
          </Stack>
          : false
        }
        <Typography variant="subtitle1" sx={{ margin: '.6em 0' }}>
          {' '}
          {typeSubtype}
        </Typography>
        <Typography variant="subtitle1" sx={{ margin: '.6em 0' }}>
          {' '}
          {location}
        </Typography>

        {isVideoMonitoringPage && <Grid sx={{ display: 'flex', alignContent: 'center', justifyContent: 'space-evenly' }}>
          {
            <Tooltip title={translate('Add Report')}>
              <Chip
                disabled={!code}
                onClick={() => {
                  handleImportDispatch(id)
                  showCheckbox.set(false)
                }}
                label={
                  <Typography variant="subtitle1" >
                    {translate('Add')}
                  </Typography>
                }
              />
            </Tooltip>

          }
          {verifyPermission(['video_surveillance_associate_occurrence']) &&
            <Tooltip title={translate('Associate to Report')}>

              <Chip
                onClick={() => {
                  handleImportDispatch(id)
                  showCheckbox.set(true)
                }}
                label={
                  <Typography variant="subtitle1" >
                    {translate('Associate')}
                  </Typography>}
              />
            </Tooltip>

          }
        </Grid>}
      </CardContent>
    </Card>
  )
}